import { Search } from '../Search';
import { ThemeToggle } from '../ThemeToggle';

interface HeaderActionsProps {
  showSearch: boolean;
  showThemeToggle: boolean;
}

export function HeaderActions({ showSearch, showThemeToggle }: HeaderActionsProps) {
  return (
    <div className="flex items-center space-x-2 sm:space-x-4">
      {showSearch && (
        <Search variant="default" />
      )}
      
      {showThemeToggle && (
        <ThemeToggle />
      )}
    </div>
  );
}